import { propertyFinanceSchema } from "../../../models/property";
import { Form, Formik } from "formik";
import useProperties from "../../../hooks/use-properties";
import Finance from "../AddFormComponents/Finance";
import {
  sanitizeValues,
  toInitialValuesFromSchema,
} from "../../../models/utils";
import { useState } from "react";
import Callout from "../../UI/Callout";
import { ModalDialogFooter } from "../../UI/ModalDialog";
import { handleAPIError } from "../../../utils/index.jsx";
import FormikSubmitButton from "../../UI/FormikSubmitButton";

function DescriptionFinanceForm({ property, closeModal }) {
  const { updateProperty } = useProperties();
  const [error, setError] = useState("");

  if (!property) return null;

  async function submitHandler(values, { setSubmitting }) {
    try {
      await updateProperty(property.id, sanitizeValues(values));
      closeModal();
      setError("");
    } catch (error) {
      setError(handleAPIError(error));
    }
    setSubmitting(false);
  }

  const initialValues = toInitialValuesFromSchema(
    propertyFinanceSchema,
    property,
  );

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={submitHandler}
      validationSchema={propertyFinanceSchema}
    >
      {() => {
        return (
          <Form>
            <Finance />
            <Callout variant="danger">{error}</Callout>
            <ModalDialogFooter>
              <FormikSubmitButton>Valider</FormikSubmitButton>
            </ModalDialogFooter>
          </Form>
        );
      }}
    </Formik>
  );
}

export default DescriptionFinanceForm;
